import { render } from "./FrmReadingDumpMerchandiseLogisticUnit.vue?vue&type=template&id=33dfca38&scoped=true"
import script from "./FrmReadingDumpMerchandiseLogisticUnit.vue?vue&type=script&lang=js"
export * from "./FrmReadingDumpMerchandiseLogisticUnit.vue?vue&type=script&lang=js"

import "./FrmReadingDumpMerchandiseLogisticUnit.vue?vue&type=style&index=0&id=33dfca38&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33dfca38"]])

export default __exports__